import {AfterViewInit, Component, ElementRef, HostBinding, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {PricingArea} from '../../data/pricing-area';
import {debounceTime} from 'rxjs/operators';
import {ColumnSettings} from 'handsontable/settings';
import Handsontable from 'handsontable';
import {Subscription} from 'rxjs';
import {ProjectCalcService} from '../../data/project-calc.service';
import {PricingSettingItem} from '../../data/pricing-setting';
import moment from 'moment';

@Component({
  selector: 'app-settings-table-sheet',
  templateUrl: './settings-table-sheet.component.html',
  styleUrls: ['./settings-table-sheet.component.scss']
})
export class SettingsTableSheetComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input()
  area: PricingArea;

  @Input()
  pricingId: number

  @ViewChild('table')
  tableEl: ElementRef;

  table: Handsontable;

  customTableLoading = true;
  progressBarLoading = true;

  @HostBinding('class.settings-table')
  settingsTable = true;

  settingsSubj: Subscription

  settingsMap = new Map<number, PricingSettingItem>();

  constructor(
    private projectCalcService: ProjectCalcService
  ) {
  }

  ngOnInit(): void {
    this.settingsSubj = this.projectCalcService.settingsSubj.pipe(debounceTime(500)).subscribe(areaId => {
      this.fillSettingsData(areaId)
    })
    this.projectCalcService.settingsSubj.next(this.area.id)
  }

  ngAfterViewInit() {
    this.fillSettingsTable()
  }

  fillSettingsData(areaId: number) {
    // this.customTableLoading = true;
    this.progressBarLoading = true;

    this.projectCalcService.getSettings(this.pricingId, areaId).subscribe(settingsData => {
      this.table.updateData(settingsData.items)

      this.table.updateSettings({
        cells: (row, col, prop) => {
          const cellProperties = {} as ColumnSettings;
          const item = settingsData.items[row]
          if (item) {
            this.settingsMap.set(row, item)

            if (prop === 'value.value') {
              cellProperties.type = item.type;
              if (item.type === 'dropdown') {
                cellProperties.source = this.getMiscGroup(item.field);
              }
            }

            if (item.field === 'boxGrade') {
              cellProperties.source = this.projectCalcService.boxGrades.map(grade => grade.name);
            } else if (item.field === 'materialGrade') {
              cellProperties.source = this.projectCalcService.matGrades.map(grade => grade.name);
            }
          }


          return cellProperties;
        }
      })
      this.customTableLoading = false;
      this.progressBarLoading = false;
    }, () => {
      this.customTableLoading = false;
      this.progressBarLoading = false;
    })
  }

  fillSettingsTable() {
    this.table = new Handsontable(this.tableEl.nativeElement, {
      data: [],
      height: '35em',
      rowHeaders: true,
      rowHeaderWidth: 30,
      colHeaders: ['Name', 'Value'],
      columns: [
        {data: 'name', type: 'text', readOnly: true},
        {data: 'value.value'}
      ],
      colWidths: [200, 200],
      // manualColumnResize: true,
      licenseKey: 'non-commercial-and-evaluation', // for non-commercial use only
      contextMenu: false,
      afterChange: (changes) => {
        if (changes) {

          const tempArea = {
            id: this.area.id
          } as PricingArea;

          const dataArr = this.table.getData();
          dataArr.forEach((data, index) => {
            const settingObj = this.settingsMap.get(index)
            const fieldName = data[0]
            const val = data[1]


            if (fieldName === 'Grade box' || fieldName === 'Grade finish material') {
              tempArea[settingObj.field] = this.projectCalcService.gradesItemsMap.get(val)
            } else if (
              fieldName === 'Finish comment' ||
              fieldName === 'Installation markup, %' ||
              fieldName === 'Tall cabs height' ||
              fieldName === 'Upper cabs height' ||
              fieldName === 'Installation estimate') {
              tempArea[settingObj.field] = val
            } else {
              tempArea[settingObj.field] = this.projectCalcService.miscItemsMap.get(val)
            }
          })

          const timeStamp = moment().format('YYYY-MM-DDTHH:mm:ss');
          tempArea.lastInteractionTime = timeStamp

          this.projectCalcService.updateArea(this.pricingId, tempArea).subscribe(() => {
            this.projectCalcService.emitAllUpdates(this.area.id)
          })
        }
      }
    });
  }

  getMiscGroup(itemField: string) {
    if (this.projectCalcService.miscGroupsMap.has(itemField)) {
      return this.projectCalcService.miscGroupsMap.get(itemField)
    }

    return this.projectCalcService.miscItemsArr;
  }

  ngOnDestroy() {
    if (this.settingsSubj) {
      this.settingsSubj.unsubscribe()
      this.settingsSubj = null;
    }
  }
}
